export default {
    intro: 'Look at the definition and choose the correct word!',
    th: {
        order: 'Number',
        meaning: 'Question',
        answer: 'Correct Answer',
        wrong: 'Wrong Answer',
        wrongChoices: 'Incorrect Choices',
        correctRate: 'Accuracy',
    },
    manySelectedWrongAnswer: 'Most Selected Incorrect Answer',
};
